import { Title } from "./styled";

function PageHeader({ title }) {
  return <Title>{title}</Title>;
}

export default PageHeader;
